import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { StorageOperation } from "../../../../api/graphql";
import { ShowString } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { ShowDateTime } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type TenantStorageUsageViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  operationOptions: { id: string; displayId: string }[];
  operation: StorageOperation;
  bytesValue?: { displayId: string; id: string } | null;
  bytes: number;
  documentNameValue?: { displayId: string; id: string } | null;
  documentName: string;
  documentIdValue?: { displayId: string; id: string } | null;
  documentId: string;
  fileTypeValue?: { displayId: string; id: string } | null;
  fileType: string;
  timestampValue?: { displayId: string; id: string } | null;
  timestamp: Date | null;
  balanceAfterValue?: { displayId: string; id: string } | null;
  balanceAfter: number;
};

export const TenantStorageUsageViewForm: React.FC<TenantStorageUsageViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      operationOptions = [],
      operation = "" as StorageOperation,
      bytes = 0,
      documentName = "",
      documentId = "",
      fileType = "",
      timestamp = null,
      balanceAfter = 0,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupTenantStorageUsageLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowString
                  value={
                    operation
                      ? operationOptions.find(
                          (o: { id: string }) => o.id === operation
                        )?.displayId || operation
                      : ""
                  }
                  label={langStore.TenantStorageUsageOperationLabel}
                />
                <ShowNumber
                  value={bytes}
                  label={langStore.TenantStorageUsageBytesLabel}
                />
                <ShowMultiLine
                  value={documentName}
                  label={langStore.TenantStorageUsageDocumentNameLabel}
                />
                <ShowMultiLine
                  value={documentId}
                  label={langStore.TenantStorageUsageDocumentIdLabel}
                />
                <ShowMultiLine
                  value={fileType}
                  label={langStore.TenantStorageUsageFileTypeLabel}
                />
                <ShowDateTime
                  value={timestamp}
                  label={langStore.TenantStorageUsageTimestampLabel}
                />
                <ShowNumber
                  value={balanceAfter}
                  label={langStore.TenantStorageUsageBalanceAfterLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
